import { useContext } from 'react';
import { AdEditorContext } from 'context/AdEditorContext';

const useAdEditorContext = () => {
  return { ...useContext(AdEditorContext) };
};

export default useAdEditorContext;
